import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthCookie } from "../../utils/cookie";

const initialState = {
  myDeliveries: null,
  loading: false,
  error: null,
  pendingDelveries: {},
  deliveryRequests: [],
  deliveryPartners: [],
  mydeliveries: [],
  myDeliveriesLoading: false,
  myDeliveryError: null,
  resendStatus: null,
  stats: null,
  orderChart: null,
  revenueChart: null,
  resendCodeLoading: false,
  assignPartnerLoading: false,
  senderPickupVerification: false,
  editPersonLoading: false,
  trackingData: null,
  manualDeliveryResponse: null,
  deliveryFee: null,
  deliverySettings: null,
};

export const fetchDeliveries = createAsyncThunk(
  "deliveries/my-deliveries",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No token found");
      }
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/deliveries/my-deliveries`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch deliveries" },
      );
    }
  },
);

export const fetchDeliveriesPending = createAsyncThunk(
  "deliveries/pending",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No token found");
      }
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/deliveries/pending`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: "Failed to fetch deliveries pending",
        },
      );
    }
  },
);

export const fetchAllDeliveryRequests = createAsyncThunk(
  "deliveries/fetchDeliveryRequests",
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No token found");
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/delivery-requests?page=${page}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return {
        data: response.data?.data || [],
        pagination: response.data?.pagination || {
          total: 1,
          page,
          limit,
          total_pages: 1,
        },
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: "Failed to fetch delivery requests",
        },
      );
    }
  },
);
// Add Delivery Person
export const AddDeliveryPartner = createAsyncThunk(
  "dashboards/addDeliveryPartner",
  async (partnerData, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No token found");
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/company/partners/`,
        partnerData, // Data sent in POST body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to create partner" },
      );
    }
  },
);
// Get Delivery Person
export const fetchDeliveryPartner = createAsyncThunk(
  "deliveries/fetchDeliveryPartner",
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No token found");
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/company/partners/?page=${page}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return {
        data: response.data?.data || [],
        pagination: response.data?.pagination || {
          total: 1,
          page,
          limit,
          total_pages: 1,
        },
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: "Failed to fetch delivery partners",
        },
      );
    }
  },
);
// Fetch Deliveries
export const fetchMyDeliveries = createAsyncThunk(
  "deliveries/fetchMyDeliveries",
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No token found");
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/my-deliveries?page=${page}&limit=${limit}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return {
        data: response.data?.data || [],
        pagination: response.data?.pagination || {
          total: 1,
          page,
          limit,
          total_pages: 1,
        },
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch my deliveries" },
      );
    }
  },
);
// Assign delivery partner

export const assignPartner = createAsyncThunk(
  "deliveries/assignPartner",
  async ({ partner_id, delivery_request_id }, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No token found");
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/assign-partner`,
        { partner_id, delivery_request_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          "Something went wrong",
      );
    }
  },
);

// verify-code
export const verifyCode = createAsyncThunk(
  "auth/verifyCode",
  async (delivery_code, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No auth token found");
      }
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/verify-code`,
        delivery_code,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Code verification failed" },
      );
    }
  },
);
//resend code
export const resendCode = createAsyncThunk(
  "auth/resendCode",
  async (delivery_id, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No auth token found");
      }
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/resend-delivery-code/${delivery_id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Code verification failed" },
      );
    }
  },
);
// company dashboard stats
export const dashboardStats = createAsyncThunk(
  "deliveries/dashboardStats",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getAuthCookie();
      if (!token) {
        throw new Error("No token found");
      }
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/company/dashboard/stats`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch dashboard stats" },
      );
    }
  },
);
//order chart data
export const fetchOrderchart = createAsyncThunk(
  "deliveries/fetchOrderchart",
  async ({ year, month }, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) throw new Error("No token found");

      let url = `${process.env.REACT_APP_API_URL}/company/dashboard/orders-chart?year=${year}`;
      if (month) url += `&month=${month}`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch Order chart" },
      );
    }
  },
);
// revenue chart data
export const fetchRevenuechart = createAsyncThunk(
  "deliveries/fetchRevenuechart",
  async ({ year, month }, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) throw new Error("No token found");

      let url = `${process.env.REACT_APP_API_URL}/company/dashboard/revenue-chart?year=${year}`;
      if (month) url += `&month=${month}`;

      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch Revenue chart" },
      );
    }
  },
);
// edit delivery person
export const editDeliveryPerson = createAsyncThunk(
  "dashboards/editDeliveryPerson",
  async ({ partner_id, name, email, phone }, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) throw new Error("No token found");

      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/company/partners/${partner_id}`,
        { name, email, phone },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: "Failed to update delivery partner",
        },
      );
    }
  },
);
// update delivery partner status
export const updatePartnerStatus = createAsyncThunk(
  "dashboards/updatePartnerStatus",
  async ({ partner_id, is_active }, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) throw new Error("No token found");

      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/company/partners/${partner_id}/status`,
        { is_active },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to update partner status" },
      );
    }
  },
);
// track delivery
export const trackDelivery = createAsyncThunk(
  "deliveries/trackDelivery",
  async ({ tracking_mode, id }, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/track/delivery`,
        { tracking_mode, id },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: "Failed to fetch delivery tracking details",
        },
      );
    }
  },
);
// create manual delivery request
export const createManualDeliveryRequest = createAsyncThunk(
  "deliveries/createManualDeliveryRequest",
  async (payload, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) throw new Error("No token found");

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/manual-delivery-request`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: "Failed to create manual delivery request",
        },
      );
    }
  },
);
// calculate delivery fee
export const calculateDeliveryFee = createAsyncThunk(
  "cart/calculateDeliveryFee",
  async ({ customer_address, store_address }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/distance/calculate`,
        { customer_address, store_address },
      );
      return response.data;
    } catch (error) {
      console.error("Delivery Fee API Error:", error);
      return rejectWithValue(
        error.response?.data || { message: "Failed to calculate delivery fee" },
      );
    }
  },
);
// verify sender pickup
export const verifySenderPickup = createAsyncThunk(
  "deliveries/verifySenderPickup",
  async ({ unique_code, otp }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/verify-sender-pickup`,
        { unique_code, otp },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to verify sender pickup" },
      );
    }
  },
);
// create delivery settings
export const createDeliverySettings = createAsyncThunk(
  "deliveries/createOrUpdateDeliverySettings",
  async (payload, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) throw new Error("No token found");

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/delivery-settings`,

        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Failed to save delivery settings" },
      );
    }
  },
);
// fetch delivery settings
export const fetchDeliverySettings = createAsyncThunk(
  "deliveries/fetchDeliverySettings",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthCookie();
      if (!token) throw new Error("No token found");

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/delivery-settings`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || {
          message: "Failed to fetch delivery settings",
        },
      );
    }
  },
);

const newBuilderSlice = createSlice({
  name: "dashboards",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch delivery Cases
      .addCase(fetchDeliveries.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeliveries.fulfilled, (state, action) => {
        state.loading = false;
        state.myDeliveries = action.payload;
        state.success = true;
      })
      .addCase(fetchDeliveries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch website";
      })
      // Fetch delivery pending Cases
      .addCase(fetchDeliveriesPending.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeliveriesPending.fulfilled, (state, action) => {
        state.loading = false;
        state.pendingDelveries = action.payload;
        state.success = true;
      })
      .addCase(fetchDeliveriesPending.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch website";
      })
      // fetch all delivery Request
      .addCase(fetchAllDeliveryRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllDeliveryRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.deliveryRequests = action.payload;
      })
      .addCase(fetchAllDeliveryRequests.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to fetch delivery requests";
      })
      // Add delivery Person
      .addCase(AddDeliveryPartner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(AddDeliveryPartner.fulfilled, (state, action) => {
        state.loading = false;

        if (!state.partners) state.partners = [];
        state.partners.push(action.payload);
      })
      .addCase(AddDeliveryPartner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to create partner";
      })
      // Fetch delivery partner
      .addCase(fetchDeliveryPartner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeliveryPartner.fulfilled, (state, action) => {
        state.loading = false;
        state.deliveryPartners = action.payload;
      })
      .addCase(fetchDeliveryPartner.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to fetch delivery partners";
      })
      // Fetch my deleveries
      .addCase(fetchMyDeliveries.pending, (state) => {
        state.myDeliveriesLoading = true;
        state.myDeliveryError = null;
      })
      .addCase(fetchMyDeliveries.fulfilled, (state, action) => {
        state.myDeliveriesLoading = false;
        state.mydeliveries = action.payload;
      })
      .addCase(fetchMyDeliveries.rejected, (state, action) => {
        state.myDeliveriesLoading = false;
        state.myDeliveryError =
          action.payload?.message || "Failed to fetch delivery partners";
      })
      // Assign Delivery Partner
      .addCase(assignPartner.pending, (state) => {
        state.assignPartnerLoading = true;
        state.error = null;
      })
      .addCase(assignPartner.fulfilled, (state, action) => {
        state.assignPartnerLoading = false;
        state.successMessage = "Partner assigned successfully";
      })
      .addCase(assignPartner.rejected, (state, action) => {
        state.assignPartnerLoading = false;
        state.error = action.payload || "Failed to assign partner";
      })

      .addCase(verifyCode.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })

      .addCase(verifyCode.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })

      .addCase(verifyCode.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload?.message || "Code verification failed";
      })
      // resend Code
      .addCase(resendCode.pending, (state) => {
        state.resendCodeLoading = true;
        state.resendStatus = null;
      })
      .addCase(resendCode.fulfilled, (state, action) => {
        state.resendCodeLoading = false;
        state.resendStatus =
          action.payload?.message || "OTP resent successfully!";
      })
      .addCase(resendCode.rejected, (state, action) => {
        state.resendCodeLoading = false;
        state.resendStatus = action.payload?.message || "Failed to resend OTP";
      })
      // company dashboard stats
      .addCase(dashboardStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(dashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload;
      })
      .addCase(dashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch stats";
      })
      //fetch order chart

      .addCase(fetchOrderchart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderchart.fulfilled, (state, action) => {
        state.loading = false;
        state.orderChart = action.payload;
      })
      .addCase(fetchOrderchart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch stats";
      })
      // fetch revenue chart data
      .addCase(fetchRevenuechart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRevenuechart.fulfilled, (state, action) => {
        state.loading = false;
        state.revenueChart = action.payload;
      })
      .addCase(fetchRevenuechart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch stats";
      })
      //edit delivery person
      .addCase(editDeliveryPerson.pending, (state) => {
        state.editPersonLoading = true;
        state.error = null;
      })
      .addCase(editDeliveryPerson.fulfilled, (state, action) => {
        state.editPersonLoading = false;
      })
      .addCase(editDeliveryPerson.rejected, (state, action) => {
        state.editPersonLoading = false;
        state.error =
          action.payload?.message || "Failed to update delivery partner";
      })
      // update delivery partner status
      .addCase(updatePartnerStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePartnerStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updatePartnerStatus.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to update partner status";
      })
      // track delivery
      .addCase(trackDelivery.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(trackDelivery.fulfilled, (state, action) => {
        state.loading = false;
        state.trackingData = action.payload;
      })
      .addCase(trackDelivery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to track delivery";
      })
      // create manual delivery request
      .addCase(createManualDeliveryRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createManualDeliveryRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.manualDeliveryResponse = action.payload;
      })
      .addCase(createManualDeliveryRequest.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to create manual delivery request";
      })
      // calculate delivery fee
      .addCase(calculateDeliveryFee.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(calculateDeliveryFee.fulfilled, (state, action) => {
        state.loading = false;
        state.deliveryFee = action.payload;
      })
      .addCase(calculateDeliveryFee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something went wrong";
      })
      // verify sender pickup
      .addCase(verifySenderPickup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifySenderPickup.fulfilled, (state, action) => {
        state.loading = false;
        state.senderPickupVerification = action.payload;
      })
      .addCase(verifySenderPickup.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to verify sender pickup";
      })
      // create delivery settings
      .addCase(createDeliverySettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDeliverySettings.fulfilled, (state, action) => {
        state.loading = false;
        state.deliverySettings = action.payload;
        state.successMessage = "Delivery settings saved successfully!";
      })
      .addCase(createDeliverySettings.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to save delivery settings";
      })
      // fetch delivery settings

      .addCase(fetchDeliverySettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeliverySettings.fulfilled, (state, action) => {
        state.loading = false;
        state.deliverySettings = action.payload;
      })
      .addCase(fetchDeliverySettings.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to fetch delivery settings";
      });
  },
});

export const { resetAuthState } = newBuilderSlice.actions;
export default newBuilderSlice.reducer;
